import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { Physician } from "src/app/models/physician";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Appointment } from "src/app/models/appointment";
import { countBy, filter } from "underscore";
import { count } from "console";
import moment from "moment";
import { TrimFormValuesService } from "src/app/common/trimmingForm";

// import { BarRatingModule } from "ngx-bar-rating";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
@Component({
  selector: "app-doctor-search",
  templateUrl: "./doctor-search.component.html",
  styleUrls: ["./doctor-search.component.css"],
})
export class DoctorSearchComponent implements OnInit {
  @ViewChild('showfeedbackModal', { static: true } as any) showfeedbackModal: TemplateRef<any>;
  @ViewChild("scheduleRequestModal", { static: true } as any)


  scheduleRequestModal: TemplateRef<any>;
  specialitiesList: any = [];
  feedback: any = [];
  searchForm: UntypedFormGroup;
  physicians: Physician[];
  rating_test: number = 3.5;
  //Pagination Parameters
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  states: any = [];
  noPhysician: boolean = false;
  feedbackColors = Utils.FEEDBACK_COLORS;
  starSize = Utils.STAR_SIZE;
  totalMembers = [];
  selectedPhysician: Number;
  selectedPatient: Number;
  defaultDr = Utils.DEFAULTDR;
  public workingHours = [];
  excludeDays: number[];
  leaves: number[];
  hours_start: number[];
  hours_end: number[];
  min_start: number[];
  min_end: number[];

  ondays: number;
  workingdays: Array<{ day: string }> = [];
  empList: Array<{}> = [];
  public show: boolean = false;
  public buttonName: any = 'Show';
  days: number;
  hour_start: number;
  hour_end: number;
  mins_start: number;
  mins_end: number;
  totalstar_count: any;
  onestar_count: number;
  twostar_count: number;
  threestar_count: number;
  fourstar_count: number;
  fivestar_count: number;
  average_rating: number;
  timeSlots: Appointment[];
  endDate: any;
  startDate: NgbDate;
  hoveredDate: NgbDate | null = null;
  illness_list = [];
  panel_expa: boolean = false;
  panel_expa2: boolean = false;
  panel_expa1: boolean = false;
  tmpl_expa: boolean = false;
  tmpl_expa1: boolean = false;
  tmpl_expa2: boolean = false;

  currentDate = Utils.maxDate;
  selectedItems = [];
  dropdownSettings = {};



  // timeSlots: import("/home/roshan/github code/SoopDoc/src/app/models/appointment").Appointment[];
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private modal: NgbModal,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
    private trimFormValuesService: TrimFormValuesService,
    private utils: Utils
  ) { }

  ngOnInit() {
    this.getIllnessList();
    this.getSpecialitiesList();
    this.loadStates();
    this.searchForm = this._formBuilder.group({
      name: [""],
      speciality: [],
      city: [""],
      date: [""],
      time: [""],
      illness: [""],
    });
    this.route.queryParams.subscribe((routeParams) => {
      this.searchForm.patchValue({
        speciality:
          routeParams && routeParams.speciality ? routeParams.speciality : "0",
      });
      this.searchForm.patchValue({
        city: routeParams && routeParams.city ? routeParams.city : "",
      });
      this.searchDoctor(1);

    });

    // this.dropdownList = [
    //   { id: 1, itemName: 'Cough' },
    //   { id: 2, itemName: 'Cold' },
    //   { id: 3, itemName: 'Fever' },
    //   { id: 4, itemName: 'Allergy' },
    //   { id: 5, itemName: 'Back Pain' },
    //   { id: 6, itemName: 'Rashes' },
    //   { id: 7, itemName: 'Fungual' },
    //   { id: 8, itemName: 'Giddyness' },
    //   { id: 9, itemName: 'Red Eye' },
    //   { id: 10, itemName: 'Shivering' }
    // ];
    // this.selectedItems = [
    //   { id: 2, itemName: 'Singapore' },
    //   { id: 3, itemName: 'Australia' },
    //   { id: 4, itemName: 'Canada' },
    //   { id: 5, itemName: 'South Korea' }
    // ];
    this.dropdownSettings = {
      singleSelection: false,
      text: 'List your Illness here',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };
  }

  datePatchInsert() {

    this.searchForm.patchValue({
      date: { year: this.currentDate.year, month: this.currentDate.month, day: this.currentDate.day }
    })

  }



  datePatchDelete() {
    this.searchForm.patchValue({
      date: [""]
    })
  }
  getIllnessList() {
    this.spinner.show();
    this.service
      .getIllnessList()
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.illness_list = res;


          this.illness_list.forEach(x => {
            x.itemName = x.illness;
            delete x.illness;
            delete x.ill_status;
          });
          console.log("Illness lIst", this.illness_list);
        },
        (error) => {
          this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  onItemSelect(item: any) {
    console.log("OnItemDeSelect", item);
    console.log(this.illness_list);
  }
  OnItemDeSelect(item: any) {
    console.log("OnItemDeSelect", item);
    console.log(this.illness_list);
  }
  onSelectAll(items: any) {
    console.log("onSelectAll", items);
  }
  onDeSelectAll(items: any) {
    console.log("onDeSelectAll", items);
  }

  dateTimeChangeEvent(ev = null) {
    // Set EndTime
    let { startTime, startDate, endTime } = this.searchForm.value;
    console.log("this.scheduleAppointmentForm.value", this.searchForm.value)
    if (endTime) {
      console.log("endTime")
      // this.validateEndTime();
    }
    else {
      if (startTime) {
        console.log("startTime")
        this.searchForm.patchValue({

          endTime: Utils.constructTime(startTime, Utils.defaultEndTimeAddon)
        })
        console.log("endTime", this.searchForm.patchValue({

          endTime: Utils.constructTime(startTime, Utils.defaultEndTimeAddon)
        }))
      }
    }
    // Validate Start Time
    if (startTime && startDate) {
      let isInvalid = Utils.validateStartTime(startTime, startDate);
      if (isInvalid) {
        this.searchForm.controls['startTime'].setErrors({ 'invalidStartTime': isInvalid })
      }
      else {
        this.searchForm.controls['startTime'].setErrors(null)
      }
    }
  }


  onDateSelection(date: NgbDate, datepicker: any) {
    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (this.startDate && !this.endDate && date) {
      this.endDate = date;
      datepicker.close();
    } else {
      this.endDate = null;
      this.startDate = date;
    }
  }
  isHovered(date: NgbDate) {
    return (
      this.startDate && !this.endDate && this.hoveredDate && date.after(this.startDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.endDate && date.after(this.startDate) && date.before(this.endDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDate) ||
      (this.endDate && date.equals(this.endDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }






  showfeedback($event, physician): void {
    this.fetchFeedback(physician.u_id);
    this.modal.open(this.showfeedbackModal, { size: 'lg', centered: true, backdrop: 'static' });
  }
  getDayName = {
    '0': 'Sun',
    '1': 'Mon',
    '2': 'Tue',
    '3': 'Wed',
    '4': 'Thu',
    '5': 'Fri',
    '6': 'Sat'
  }
  fetchFeedback(uid) {
    this.spinner.show();
    this.service.getFeedbackdr(uid).subscribe(
      (res) => {
        this.spinner.hide();
        this.feedback = res;
        const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        if (res) {
          res.forEach(function (x) { counts[x.rating] = (counts[x.rating] || 0) + 1; });
          this.onestar_count = counts[1];
          this.twostar_count = counts[2];
          this.threestar_count = counts[3];
          this.fourstar_count = counts[4];
          this.fivestar_count = counts[5];
        }
        else {
          this.onestar_count = counts[1];
          this.twostar_count = counts[2];
          this.threestar_count = counts[3];
          this.fourstar_count = counts[4];
          this.fivestar_count = counts[5];

        }
        this.totalstar_count = this.onestar_count + this.twostar_count + this.threestar_count + this.fourstar_count + this.fivestar_count;
        let fiv_star = 5 * this.fivestar_count
        let four_star = 4 * this.fourstar_count
        let three_star = 3 * this.threestar_count
        let two_star = 2 * this.twostar_count
        let one_star = 1 * this.onestar_count
        let total_rating = fiv_star + four_star + three_star + two_star + one_star
        let total_star = this.totalstar_count
        let avar_total_star = total_rating / this.totalstar_count
        if (avar_total_star) {
          this.average_rating = avar_total_star
        }
        else {
          this.average_rating = 0
        }
        // this.average_rating = avar_total_star
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  getSpecialitiesList() {
    this.spinner.show();
    this.service.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  loadStates(): any {
    this.spinner.show();
    this.service.getStates(1).subscribe((res) => {
      this.spinner.hide();
      this.states = res;
    });
  }
  toggle(i) {
    if (i.show) {
      i.show = !i.show;
    }
    else {
      i.show = !this.show;
    }

    // Change the name of the button.
    if (i.show)
      i.buttonName = "Less";
    else
      i.buttonName = "More";
  }

  searchDoctor(pg: number = 1) {
    console.log("this.searchForm.value before", this.searchForm.value)
    this.trimFormValuesService.trimValues(this.searchForm.controls);
    console.log("this.searchForm.value after", this.searchForm.value)
    let data = {
      verified: true,
    };
    console.log("this.searchForm.value.name")
    if (this.searchForm.value.name) {
      data["name"] = this.searchForm.value.name.trim();
    }
    if (parseInt(this.searchForm.value.speciality)) {
      data["speciality"] = parseInt(this.searchForm.value.speciality);
    }
    if (this.searchForm.value.city) {
      data["location"] = this.searchForm.value.city;
    }
    if (this.searchForm.value.time) {
      data['time'] = this.searchForm.value.time.hour + ':' + this.searchForm.value.time.minute + ':' + parseInt(moment().format("ss"));
    }
    if (this.searchForm.value.date) {
      data['date'] = `${this.searchForm.value.date.year}-${this.searchForm.value.date.month}-${this.searchForm.value.date.day}`;
    }
    if (this.searchForm.value.illness) {
      if (this.searchForm.value.illness.length === 0) {
        delete this.searchForm.value.illness;
      } else {
        data['illness'] = this.searchForm.value.illness;
      }
    }
    console.log("data", data)
    if (pg) {
      this.page = pg;
    }

    this.spinner.show();
    this.service
      .fetchPhysicians(data, `?page=${this.page}&limit=${this.pagesize}`)
      .subscribe(
        (res) => {
          console.log("doctor search response:", res);
          this.spinner.hide();
          this.physicians = [...res["result"]];
          this.collectionSize = res["total_count"];
          if (this.physicians && this.physicians.length) {
            this.physicians.forEach(async (x) => {
              if (x.physician_qualification) {
                x.qualification = x.physician_qualification[0].qualification;
              }

              if (x.physician_speciality) {
                x.physician_speciality = this.getPhysicianSpecialities(
                  x.physician_speciality
                );
              }
              if (x.u_id) {
                this.service.getWorkingHours(x.u_id).subscribe(
                  (res: any) => {
                    this.spinner.hide();
                    if (res && res.length > 0) {
                      this.workingHours = res;
                      this.excludeDays = [];
                      this.leaves = [];
                      this.hours_start = [];
                      this.hours_end = [];
                      this.min_start = [];
                      this.min_end = [];
                      // this.ondays = [];
                      this.workingHours.map(x => {
                        x.dayName = this.getDayName[x.day];
                        x.start_time = x.start_time.split(':');
                        x.start_time = { hour: parseInt(x.start_time[0]), minute: parseInt(x.start_time[1]) };
                        x.end_time = x.end_time.split(':');
                        x.end_time = { hour: parseInt(x.end_time[0]), minute: parseInt(x.end_time[1]) };
                        // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
                        // console.log("x.start_time", x.start_time)
                        // console.log("x.end_time", x.end_time)
                        // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
                        // console.log("x.start_time.hour", x.start_time.hour)
                        // console.log("x.end_time.hour", x.end_time.hour)
                        this.hour_start = this.hours_start.push(x.start_time.hour)
                        this.hour_end = this.hours_end.push(x.end_time.hour)
                        this.mins_start = this.min_start.push(x.start_time.minute)
                        this.mins_end = this.min_end.push(x.end_time.minute)
                        if (x.start_time.hour && x.end_time.hour) {
                          this.ondays = this.leaves.push(x.day)
                          // console.log("this.excludeDays", this.leaves)
                          this.days = this.excludeDays.push(x.dayName)
                          // console.log("this.workingHours start time", x.start_time.hour)
                          // console.log("this.workingHours end time", x.end_time)
                          // this.hour_end = this.hours.push(x.end_time.hour, x.end_time.minute)
                        }
                      });

                      // console.log("this.workingHours start time", this.workingHours.start_time)
                      // console.log("this.workingHours end time", this.workingHours.end_time)

                    }
                    var c_date = new Date().getTime();
                    var c_date1 = new Date().getTimezoneOffset();
                    var today = (new Date()).getDay();
                    // console.log("today", today)
                    const d = new Date();
                    let hour = d.getHours();
                    let min = d.getMinutes();
                    // console.log("hour", hour)
                    // console.log("min", min)
                    // console.log("this.hours_start", this.hours_start)
                    // console.log("this.hours_end", this.hours_end)
                    // console.log("this.mins_start", this.min_start)
                    // console.log("this.min_end", this.min_end)
                    // console.log("this.hour_end", this.hour_end)
                    // console.log("this.hour", this.hour)
                    // console.log("this.leaves", this.leaves)
                    var finds = this.leaves.find(x => x == today);
                    // console.log("this.workingHours start time", x)
                    // console.log("this.workingHours end time", x)
                    // console.log("finds", finds)
                    // console.log("c_date", c_date)
                    // console.log("c_date1", c_date1)
                    var l_min;
                    var f_hour = this.hours_start[today];
                    var f_min = this.min_start[today];
                    var l_hour = this.hours_end[today];
                    l_min = this.min_end[today];
                    // var str1 = "10:20:45",
                    //   str2 = "10:20:45";

                    // if (str1 > str2)
                    //   console.log("Time 1 is later than time 2");
                    // else
                    //   console.log("Time 2 is later than time 1");
                    // console.log("available time morning", f_hour, '<', hour)
                    // console.log("available time evng", hour, '<', l_hour)
                    var g1 = new Date(hour, min);

                    // (YYYY, MM, DD, Hr, Min, Sec)
                    var g2 = new Date(f_hour, f_min);
                    var g3 = new Date(l_hour, l_min);
                    if ((g2.getTime() < g1.getTime()) && (g1.getTime() <= g3.getTime())) {
                      // console.log("online");
                      x["available"] = "ONLINE"
                      x["val"] = 1;
                    }

                    else {
                      // console.log("offline");
                      x["available"] = "OFFLINE"
                      x["val"] = 0
                    }


                    // Date.parse('01/02/2011') > Date.parse('01/01/2011 ')
                    //   > true

                    //                     var startTimeObject = new Date();
                    //  startTimeObject.setHours(startHour, startMinute, startSecond);

                    //  //Create date object and set the time to that
                    //  var endTimeObject = new Date(startTimeObject);
                    //  endTimeObject.setHours(endHour, endMinute, endSecond);

                    //  //Now we are ready to compare both the dates
                    //  if(startTimeObject > endTimeObject) {
                    //      alert('End time should be after start time.');
                    //  }
                    //  else {
                    //      alert('Entries are perfect.');
                    //  }

                    // var a = "10:20:45";
                    // var b = "5:10:10";

                    // var timeA = new Date();
                    // timeA.setHours(a.split(":")[0],a.split(":")[1],a.split(":")[2]);
                    // var timeB = new Date();
                    // timeB.setHours(b.split(":")[0],b.split(":")[1],b.split(":")[2]);

                    // var x= "B is later than A";
                    // if(timeA>timeB) x = "A is later than B";
                    // document.getElementById("demo").innerHTML = x;


                    // if (finds) {
                    //   if ((f_hour <= hour) && (hour <= l_hour)) {
                    //     // console.log("1111111111111111111111111111111111111111")
                    //     // console.log("available time morning", f_min, '<', min)
                    //     // console.log("available time evng", min, '<', l_min)
                    //     // if (l_min <= min) {
                    //     //   l_min = l_min;
                    //     // }
                    //     // console.log("available time morning", f_min, '<', min)
                    //     // console.log("available time evng", min, '<', l_min)
                    //     // console.log("available time evng", min, '>', l_min)
                    //     // if (f_min <= min) {
                    //     //   console.log("3333333333333333333333333333333333333")
                    //     //   if (min <= l_min) {
                    //     //     console.log("5555555555555555555555555555")

                    //     //   }
                    //     //   else {
                    //     //     console.log("6666666666666666666666666666666")
                    //     //   }
                    //     //   x["available"] = "ONLINE"
                    //     // }
                    //     // else {
                    //     //   console.log("444444444444444444444444444444444")
                    //     //   x["available"] = "OFFLINE"
                    //     // }
                    //     x["available"] = "ONLINE"
                    //     x["val"] = 1
                    //   }
                    //   else {
                    //     // console.log("2222222222222222222222222222222222222222222222")
                    //     x["available"] = "OFFLINE"
                    //     x["val"] = 0
                    //   }
                    //   // x["available"] = "ONLINE"
                    // }
                    // else {
                    //   x["available"] = "OFFLINE"
                    //   x["val"] = 0
                    // }
                    x["days"] = this.excludeDays;
                  },
                  err => {
                    this.spinner.hide();
                    console.log(err);
                  });
              }

              var curdate = (new Date().getDate()).toString() + '-' + (new Date().getMonth() + 1).toString() + '-' + new Date().getFullYear().toString();
              // console.log("curdate", curdate)
              var text = ("image name.png")
              var spl = text.split(".")
              // console.log("spl", spl)


              let day = new Date().getDate()
              let month = new Date().getMonth() + 1
              let year = new Date().getFullYear().toString()
              this.spinner.show();
              this.service
                .getappoint({
                  drid: x.u_id,
                  date: `${year}-${month}-${day}`,
                })
                .subscribe(
                  (res) => {
                    this.spinner.hide();
                    this.timeSlots = res;
                    // console.log("this.timeSlots", this.timeSlots)
                    // console.log("this.timeSlots...", this.timeSlots[0].schedule_stat)
                    // if (!(res && res.length)) {
                    //   Swal.fire({
                    //     type: "warning",
                    //     title: "Oops...",
                    //     text: "No timeslots available for this day!",
                    //   });
                    // }
                    // this.selectedItem = null;
                    // this.patientForm.get("aptime").reset();
                    // this.endTime = null;
                    // this.getSelectedSlot();
                  },
                  (error) => {
                    this.spinner.hide();
                    this.showToast(
                      "error",
                      "Something went wrong while fetching time slots. Please try again."
                    );
                  }
                );














































              x["location"] = x.city ? x.city : "";

              if (x.state) {
                x["location"] += ", " + this.getStates(x.state).toLowerCase();
              }

              if (x.physician_education && x.physician_education.length) {
                x["education"] =
                  "- " + x.physician_education.map((x) => x.degree).join(", ");
              }

              if (x.physician_consultfee) {
                if (x.consultation_share == null) {
                  x.consultation_share = '0.70'
                }
                // console.log("===========================================")
                // console.log(1 - parseFloat(x.consultation_share))
                // console.log(x.physician_consultfee[0].fee)
                // console.log("===========================================")
                let extra_charges = x.consultation_share
                  ? (1 - parseFloat(x.consultation_share)) *
                  x.physician_consultfee[0].fee
                  : 0;
                // console.log("extra_charges", extra_charges)
                x.consult_fee = x.physician_consultfee[0].fee + extra_charges;
                x["consult_fee"] = x.physician_consultfee[0].fee + extra_charges;
              }
              x.consult_fee = Math.ceil(x.consult_fee);
              // console.log("fetch Physician", res)
            });
          } else {
            this.noPhysician = true;
          }
        },
        (error) => {
          this.spinner.hide();
          console.log(error);
          let message =
            error && error.error && error.error.message
              ? error.error.message
              : "Something wrong. Couldn't complete request.";
          this.showToast("error", message);
          return;
        }
      );
  }
  //showToast function
  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  //Map Specialities
  getPhysicianSpecialities(physician_speciality): any {
    let specialities = [];
    if (this.specialitiesList && this.specialitiesList.length) {
      physician_speciality.forEach((element) => {
        let sp = this.specialitiesList.find(
          (s) => s.id == element.speciality_id
        );
        specialities.push(`${sp.name} - ${element.no_of_years}Years`);
      });
      return specialities.join(", ");
    }
  }
  //Map States
  getStates(state): string {
    if (this.states && this.states.length) {
      let location = this.states.find((x) => x.id == state);
      return location.name;
    }
    return "";
  }

  pageChanged() {
    this.searchDoctor(this.page);
  }

  gotoPage() {
    this.modal.dismissAll();
    this.router.navigate(
      [`/online-doctor-appointment/${this.selectedPhysician}`],
      { queryParams: { pid: this.selectedPatient } }
    );
  }

  scheduleRequest(physician): void {
    this.selectedPhysician = physician.u_maskid;
    if (
      localStorage.getItem("LogUsrTyp") &&
      this.utils.checkRoleType(
        Utils.USER_TYPE.patient,
        JSON.parse(localStorage.getItem("LogUsrTyp"))
      )
    ) {
      this.spinner.show();
      this.service
        .getPatientById(localStorage.getItem("uid"), "?fields=members")
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.fetchMembers(res);
          },
          (err) => {
            this.spinner.hide();
          }
        );

      this.modal.open(this.scheduleRequestModal);
    } else {
      this.router.navigate([
        `/online-doctor-appointment/${physician.u_maskid}`,
      ]);
    }
  }

  fetchMembers(data) {
    // let selfPatient = {};
    // let valuesToAdd = ['first_name', 'last_name', 'pid'];
    // for (let val of valuesToAdd) {
    //   if (data[val]) selfPatient[val] = data[val];
    // }
    if (!data.members || data.members.length === 0) data.members = [];
    // data.members.unshift(selfPatient);
    this.totalMembers = data.members;
  }

  selectMember(pid) {
    this.selectedPatient = pid;
  }
  resetForm(data) {
    console.log("this.searchForm.value.illness", this.searchForm.value.illness)
    // if (data === 'dateTime') {
    //   delete this.searchForm.value.date;
    //   delete this.searchForm.value.time;
    // }
    // else if (data === 'illness') {
    //   this.searchForm = this._formBuilder.group({
    //     name: this.searchForm.value.name,
    //     speciality: ["0"],
    //     city: [""],
    //     date: this.searchForm.value.date,
    //     time: this.searchForm.value.time,
    //     illness: [""],
    //   });
    //   delete this.searchForm.value.illness;
    // }
    // else {
    //   this.searchForm = this._formBuilder.group({
    //     name: this.searchForm.value.name,
    //     date: [""],
    //     time: [""],
    //     illness: [""],
    //   });
    //   delete this.searchForm.value.date;
    //   delete this.searchForm.value.time;
    //   delete this.searchForm.value.illness;


    // }
  }
}
